import React, { useEffect } from 'react';
import { useQuery } from '@apollo/client';

import { FULL_NAME } from '../../Account.gql';
import { useIdentity } from '../../../Authentication/Authentication.hooks';

import * as Styled from './AccountGreeting.styled';

/**
 * Displays a personalized greeting for an authenticated customer
 */
const AccountGreeting = ({ ...props }) => {
  const { eraseUser } = useIdentity();
  const { data } = useQuery(FULL_NAME, {
    context: { service: 'storefront' }
  });

  useEffect(() => {
    if (data?.customerAccessToken && !data?.customer) {
      eraseUser();
    }
  }, [data]);

  const firstName = data?.customer?.firstName;

  return (
    <Styled.AccountGreeting {...props}>
      Hi{!!firstName && ` ${firstName}`}!
    </Styled.AccountGreeting>
  );
};

export default AccountGreeting;
